<a *ngIf="openInNewPage" target="_blank" class="btn btn-link call-to-action p-0" [href]="routeLink" [class]="className">
    {{ innerText }} <ca-icon name="arrow-right" size="s" class="link-icon ms-2"></ca-icon>
</a>
<button type="button" *ngIf="!openInNewPage" type="button" class="btn btn-link call-to-action p-0" [routerLink]="routeLink" [class]="className">
    {{ innerText }} <ca-icon name="arrow-right" size="xs" class="link-icon ms-2"></ca-icon>
</button>
